import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: white;
  padding: 20px;

  @media (max-width: 1024px) {
    padding: 16px;
  }

  @media (max-width: 765px) {
    flex-direction: column;
    gap: 12px;
    padding: 12px;
  }
`;

export const Typography = styled.div`
  font-family: IBM Plex Sans;
  font-weight: 600;
  font-style: normal; 
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0;
  text-align: center;
  color: #000000;
  width: 448px;
  height:42px;

  @media (max-width: 1024px) {
    font-size: 14.5px;
    line-height: 19px;
  }

  @media (max-width: 765px) {
    font-size: 13px;
    line-height: 18px;
  }
`;

export const CarouselButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    padding: 16px;
  }

  @media (max-width: 765px) {
    flex-direction: column;
    gap: 10px;
    padding: 12px;
  }
`;

export const SliderWrapper = styled.div`
  flex: 1;
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  @media (max-width: 765px) {
    gap: 6px;
  }
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => (props.active ? '#7200E0' : '#C4A9DD')};
  transition: background-color 0.3s ease;

  @media (max-width: 765px) {
    width: 6px;
    height: 6px;
  }
`;
